<template>
  <div :visible="visible" ref="tipsBox" @update:visible="updateDialog" class="tipsBox">
    <div ref="showPopover" class="tipsClass animated">
      <div class="tip">{{tipsContent}}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    visible: Boolean,
    tipsContent: String
  },
  methods: {
    get() {
      if (this.visible) {
        this.$refs.tipsBox.children[0].className = "tipsClass";
        this.updateDialog(false);
      } else {
        this.$refs.tipsBox.children[0].className = "tipsClass animated";
      }
    },
    updateDialog(val) {
      this.$emit("update:visible", val);
    }
  },
  mounted() {
    this.timer = setInterval(this.get, 2000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>
<style lang="scss" scoped>
.tipsClass {
  width: 5rem;
  height: 0.6rem;
  padding: 0.2rem;
  background: rgb(120, 120, 120);
  font-size: 0.25rem;
  color: white;
  opacity: 1;
  border-radius: 0.05rem;
  filter: Alpha(opacity=100);
  .tip{
    line-height: 0.4rem
  }
}
.animated {
  opacity: 0;
  filter: Alpha(opacity=0);
  transition: opacity 2s;
}
</style>


// WEBPACK FOOTER //
// src/components/mobile/tipBox.vue